// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root not found in document')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
